import { render, staticRenderFns } from "./ProjectTaskDetails.vue?vue&type=template&id=27f7ba40"
import script from "./ProjectTaskDetails.vue?vue&type=script&lang=js"
export * from "./ProjectTaskDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports